module.exports = __webpack_public_path__ + "img/Operatiors_en.01002b65.png";